import * as React from 'react';
const Share = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-share", ...props },
    React.createElement("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
    React.createElement("polyline", { points: "16 6 12 2 8 6" }),
    React.createElement("line", { x1: "12", y1: "2", x2: "12", y2: "15" })));
export default Share;
//# sourceMappingURL=Share.js.map